import * as React from "react";
import { forwardRef } from "react";
const SvgAnchorLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Iconsax/Linear/arrowleft2" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M11.25 14.9396L6.36 10.0496C5.7825 9.47207 5.7825 8.52707 6.36 7.94957L11.25 3.05957", stroke: "#595E6A", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgAnchorLeft);
export default ForwardRef;
